import {BrowserRouter, Routes, Route} from 'react-router'
import PropTypes from 'prop-types'
import {Box, Container, useDisclosure} from '@chakra-ui/react'
import useSWR from 'swr'
import {ThemeProvider} from '../../components'
import Loading from '../../components/Loading'
import {fetcher} from '../../../api'
import {camelizeResult} from '../../../api/serializer'

import Header from './Header'
import Invoices from './Invoices'
import Alert from './Alert'
// We don't have a new design for this flow yet so using the current
// invalid token component as a placeholder.
import InvalidToken from '../PayerStatementScreen/InvalidToken'
import {RailsProvider} from '../../contexts/rails'
import BankAccountDetailsModal from './BankAccountDetailsModel'
import Title from './Title'

const LiveStatementScreen = ({
  payerId,
  tokenValid,
  statementPdfDownloadPath,
}) => {
  const {data: viewerData} = useSWR(
    `/api/payer_statements/customers/${payerId}/viewer`,
    fetcher,
    {
      use: [camelizeResult],
      suspense: true,
    },
  )

  const {data: headerData} = useSWR(
    `/api/payer_statements/customers/${payerId}`,
    fetcher,
    {
      use: [camelizeResult],
      suspense: true,
    },
  )

  const {data: alertsData} = useSWR(
    `/api/payer_statements/customers/${payerId}/alerts`,
    fetcher,
    {
      use: [camelizeResult],
      suspense: true,
    },
  )

  const {isOpen, onOpen, onClose} = useDisclosure()

  return (
    <RailsProvider>
      <ThemeProvider>
        <Loading>
          <Container maxWidth="full" mt={4}>
            {tokenValid ? (
              <Box>
                <Box mb={2}>
                  <Header {...headerData} />
                </Box>
                <hr />
                <Box pt={10}>
                  <Alert
                    outsidePayments={alertsData.outsidePayments}
                    payInvoice={viewerData.policies.payInvoice.visible}
                    supplierName={headerData.supplier.name}
                    onOpenBankAccountDetails={onOpen}
                    payerName={headerData.name}
                  />
                </Box>
                <Box pt={10}>
                  <Title onOpenBankAccountDetails={onOpen} />
                </Box>
                <Box pt={10}>
                  <Invoices
                    statementPdfDownloadPath={statementPdfDownloadPath}
                    payerId={payerId}
                    payable={viewerData.policies.payInvoice.visible}
                  />
                </Box>
                <BankAccountDetailsModal
                  isOpen={isOpen}
                  onOpen={onOpen}
                  onClose={onClose}
                  supplierName={headerData.supplier.name}
                  {...headerData.supplier.bankAccount}
                />
              </Box>
            ) : (
              <InvalidToken />
            )}
          </Container>
        </Loading>
      </ThemeProvider>
    </RailsProvider>
  )
}

LiveStatementScreen.propTypes = {
  tokenValid: PropTypes.bool.isRequired,
  payerId: PropTypes.string.isRequired,
  statementPdfDownloadPath: PropTypes.string.isRequired,
}

export {LiveStatementScreen}

export default function LiveStatementScreenWithRouter(props) {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/customers/:id/statement"
          element={<LiveStatementScreen {...props} />}
        />
        <Route
          path="/payer_statement/:external_payer_id"
          element={<LiveStatementScreen {...props} />}
        />
      </Routes>
    </BrowserRouter>
  )
}
